import {Button, Divider, Grid, Typography} from '@mui/material';
import {get} from 'lodash';
import React, {useState} from 'react';
import {getLabelOrValue} from '../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';
import {SubmitRow} from '../../components/PrecursorForm/SubmitRow';
import {WizardField} from '../../components/Wizard/QuestionWrapper';
import {useAccountContext} from '../../contexts/AccountContext';
import {postcursorFieldsType} from './postcursorFields';
import {uuidRegex} from '../../components/PrecursorForm/uuidRegex';
import {UPDATES} from '../../shared/UPDATES';
import {sortAccountContacts} from '../../components/AccountOverview/sortAccountContacts';

// const getInvestmentPhilosophyAnswer = (
//   values: precursorAndHeaderFieldsType,
//   field: FormField,
//   account: AccountDetails | undefined
// ): string => {
//   const contact = account?.contacts?.find(
//     (x) => x.simplifiedName === field.label
//   );
// const payload: string[] = [];
//   values.investmentPhilosophy.forEach((x) => {
//     const {contactId, field: thisField} = getInvestmentPhilosophyContactIdAndField(x);
//     if (contactId === contact?.id) {
//       payload.push(camelCaseToCapitalisedString(thisField));
//     }
//   });
//   return payload.join(', ');
// };

export function PostcursorWizardSummary({
  formFields,
  previousStep,
}: {
  formFields: WizardField<postcursorFieldsType>[];
  previousStep: () => void;
}) {
  const {account} = useAccountContext();
  const {
    values,
    submitForm,
    isSubmitting: isAboutToSubmit,
    setFieldValue,
  } = useAutoForm<postcursorFieldsType>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fields = formFields.filter(
    (field) => get(values, field.id) !== undefined && field.enabled(values)
  );
  const genericFields = formFields.filter((x) => !uuidRegex.test(x.id));

  const contactFields =
    sortAccountContacts(account?.id, account?.contacts || [])
      // ?.filter((contact) => {
      //   if (account.contacts?.length === 1) {
      //     return true;
      //   }
      //   if (reviewDetails?.contact) {
      //     return reviewDetails.contact.id === contact.id;
      //   }
      //   return true; // if no reviewDetails contact, then its a joint review and return true
      // })
      ?.map((contact) => {
        return {
          contact,
          fields: fields.filter((field) => field.id.includes(contact.id)),
        };
      }) || [];

  return (
    <div
      style={{
        left: '0px',
        right: '0px',
      }}
    >
      <Grid container spacing={5} direction="column" pr={4} pt={5}>
        <Grid container spacing={5} pl={5} maxWidth={1200}>
          <Grid item pb={5} xs={6}>
            <Typography variant="h5" pb={1}>
              General review:
            </Typography>
            <Divider flexItem className="divider" />
            {genericFields.map((f, index) => (
              <div className="generic-fields" key={f.id}>
                <SubmitRow
                  onClick={() => setFieldValue(UPDATES._1903, 'step', index)}
                  label={f.label}
                  title={f.title}
                  answer={getLabelOrValue(values as any, f)}
                />
                <Divider flexItem className="divider" />
              </div>
            ))}
          </Grid>
        </Grid>
        <Grid container spacing={5} pl={5} maxWidth={1200}>
          {contactFields.map((contact) => {
            return (
              <Grid
                key={contact.contact.id}
                className="contact-specific-fields"
                id={contact.contact.id}
                item
                xs={6}
              >
                <Typography variant="h5" pb={1}>
                  {contact.contact.simplifiedName} answers:
                </Typography>
                <Divider flexItem className="divider" />
                {contact.fields.map((f) => (
                  <Grid item key={f.id}>
                    <SubmitRow
                      onClick={() => {}}
                      key={f.id}
                      label={f.label}
                      title={f.title}
                      answer={getLabelOrValue(values as any, f)}
                    />
                    <Divider />
                  </Grid>
                ))}
              </Grid>
            );
          })}
          {account?.isTrust && (
            <Grid className="contact-specific-fields" item xs={6}>
              <Typography variant="h5" pb={1}>
                {account.name} answers:
              </Typography>
              <Divider flexItem className="divider" />
              {fields
                .filter((field) => field.id.includes(account.id))
                .map((f) => (
                  <Grid item key={f.id}>
                    <SubmitRow
                      onClick={() => {}}
                      key={f.id}
                      label={f.label}
                      title={f.title}
                      answer={getLabelOrValue(values as any, f)}
                    />
                    <Divider />
                  </Grid>
                ))}
            </Grid>
          )}
        </Grid>

        <Grid item container justifyContent="center" alignItems="center">
          <Grid item xs={8}>
            <Button variant="contained" color="secondary" onClick={previousStep}>
              Back
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setIsSubmitting(true);
                submitForm().finally(async () => {
                  setIsSubmitting(false);
                });
              }}
              data-test="Submit Review"
              disabled={isSubmitting}
            >
              {isAboutToSubmit ? 'Loading...' : 'Submit'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
